export enum SluitpotPosition {
    Dam = "dam",
    Sponning = "sponning",
    Sponning2 = "sponningzijde"
}